module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_word_x32-e5271.png";